/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maintain_Clock_TimesInputs */



/**
* | output |
* | --- |
* | "Maintain Clock Times" |
*
* @param {Maintain_Clock_TimesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const maintain_clock_times = /** @type {((inputs?: Maintain_Clock_TimesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maintain_Clock_TimesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Conserver les temps d’horloge")
	if (locale === "de") return /** @type {LocalizedString} */ ("Uhrzeiten beibehalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mantenere i tempi dell'orologio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поддерживайте точность хода часов.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mantener los tiempos del reloj")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保持时钟时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("時計の時間を維持する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घड़ी के समय को बनाए रखें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Manter a hora correta")
	return /** @type {LocalizedString} */ ("Maintain Clock Times")
});